import React from "react";

const EpaperIcon = ({ width="18", height="14", color = "white", ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_6489_1818)">
      <path
        d="M2.37296 0V1.34351H0V12.137C0 13.1645 0.737876 14 1.64525 14H16.3175C17.2452 14 18 13.1453 18 12.0948V0H2.37296ZM2.37296 12.8484H1.64525C1.29891 12.8484 1.01698 12.5292 1.01698 12.137V2.49509H2.37296V12.8484ZM16.983 12.0948C16.983 12.5106 16.6841 12.8484 16.3175 12.8484H3.38994V1.15158H16.983V12.0948Z"
        fill={color}
      />
      <path
        d="M10.0573 8.72961H4.6543V2.77914H10.0573V8.72961ZM5.55828 7.70598H9.15331V3.80277H5.55828V7.70598Z"
        fill={color}
      />
      <path
        d="M15.8356 2.61153H11.3608V3.63515H15.8356V2.61153Z"
        fill={color}
      />
      <path
        d="M15.8356 5.24224H11.3608V6.26587H15.8356V5.24224Z"
        fill={color}
      />
      <path
        d="M15.8356 7.8736H11.3608V8.89723H15.8356V7.8736Z"
        fill={color}
      />
      <path
        d="M15.8356 10.3655H11.3608V11.3891H15.8356V10.3655Z"
        fill={color}
      />
      <path
        d="M10.1743 10.3655H4.61426V11.3891H10.1743V10.3655Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_6489_1818">
        <rect width="18" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default EpaperIcon;
